(function () {
  function money(cents) {
    if (window.theme && window.theme.Currency && window.theme.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initCard(card) {
    if (card.dataset.olleInitialized === 'true') return;
    card.dataset.olleInitialized = 'true';

    var variantsNode = card.querySelector('[data-product-variants]');
    var variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    var controls = Array.prototype.slice.call(card.querySelectorAll('[data-product-option]'));
    var form = card.querySelector('.olle-home-product__form');
    var addButton = card.querySelector('[data-add-to-cart]');
    var addButtonText = card.querySelector('[data-button-text]');
    var image = card.querySelector('.olle-home-product__image');
    var media = card.querySelector('[data-product-media]');
    var selectedImage = image ? image.currentSrc || image.src : '';
    var hoverImageNode = card.querySelector('[data-hover-image]');
    var hoverImage = hoverImageNode ? hoverImageNode.textContent.trim() : '';
    var imageCache = {};
    var requestedImage = selectedImage;
    var cardImagesPreloaded = false;

    function preloadImage(url, callback) {
      if (!url) return;
      if (imageCache[url] === true) {
        if (callback) callback();
        return;
      }
      if (Array.isArray(imageCache[url])) {
        if (callback) imageCache[url].push(callback);
        return;
      }

      imageCache[url] = callback ? [callback] : [];
      var preload = new Image();
      preload.onload = function () {
        var callbacks = imageCache[url];
        imageCache[url] = true;
        callbacks.forEach(function (ready) { ready(); });
      };
      preload.onerror = function () { delete imageCache[url]; };
      preload.src = url;
    }

    function showImage(url) {
      if (!image || !url) return;
      requestedImage = url;
      if (image.src === url) return;

      preloadImage(url, function () {
        if (requestedImage !== url) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = url;
      });
    }

    function preloadCardImages() {
      if (cardImagesPreloaded) return;
      cardImagesPreloaded = true;
      controls.forEach(function (control) {
        if (control.dataset.previewImage) preloadImage(control.dataset.previewImage);
      });
    }

    function optionValues() {
      var values = [];
      card.querySelectorAll('.olle-home-product__option').forEach(function (field) {
        var control = field.querySelector('[data-product-option]:checked') || field.querySelector('[data-product-option]');
        values[Number(field.dataset.optionPosition) - 1] = control ? control.value : '';
      });
      return values;
    }

    function variantImage(variant) {
      if (!variant || !variant.featured_image) return '';
      return variant.featured_image.src || variant.featured_image.url || '';
    }

    function updateVariant() {
      var values = optionValues();
      var variant = variants.find(function (item) {
        return item.options.every(function (value, index) { return value === values[index]; });
      });
      if (!variant) return;

      var variantInput = card.querySelector('[data-variant-id]');
      var price = card.querySelector('[data-product-price]');
      var compare = card.querySelector('[data-product-compare]');
      var button = card.querySelector('[data-add-to-cart]');
      var buttonText = card.querySelector('[data-button-text]');
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
        compare.classList.toggle('is-hidden', !(variant.compare_at_price > variant.price));
      }
      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? 'Add To Cart' : 'Sold Out';
      var selectedPreview = controls.find(function (control) {
        return control.checked && control.dataset.previewImage;
      });
      var nextSelectedImage = selectedPreview ? selectedPreview.dataset.previewImage : variantImage(variant);
      if (nextSelectedImage) {
        selectedImage = nextSelectedImage;
        showImage(selectedImage);
      }
    }

    function updateCartCount() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to refresh cart');
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (count) {
            count.textContent = cart.item_count;
          });
          document.querySelectorAll('[data-cart-count-bubble], .site-header__cart-count').forEach(function (bubble) {
            bubble.classList.toggle('hide', cart.item_count === 0);
          });
        });
    }

    function openSlideCartWhenReady() {
      var attempts = 0;
      var maxAttempts = 100;

      function openCart() {
        attempts += 1;
        if (typeof window.SLIDECART_UPDATE === 'function' && typeof window.SLIDECART_OPEN === 'function') {
          window.SLIDECART_UPDATE(function () {
            window.SLIDECART_OPEN();
          });
          return;
        }
        if (attempts < maxAttempts) window.setTimeout(openCart, 100);
      }

      openCart();
    }

    function addToCart() {
      if (!form || !addButton || addButton.disabled || addButton.dataset.loading === 'true') return;

      addButton.dataset.loading = 'true';
      addButton.disabled = true;
      if (addButtonText) addButtonText.textContent = 'Adding...';

      fetch(form.action + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.text().then(function (text) {
            var json;
            try {
              json = JSON.parse(text);
            } catch (parseError) {
              json = { description: text };
            }
            if (!response.ok || (json.status && json.status !== 200)) {
              throw new Error(json.description || 'Unable to add this item');
            }
            return json;
          });
        })
        .then(function () {
          if (addButtonText) addButtonText.textContent = 'Thank you!';
          updateCartCount().catch(function () {});
          openSlideCartWhenReady();
          window.setTimeout(function () {
            addButton.dataset.loading = 'false';
            addButton.disabled = false;
            if (addButtonText) addButtonText.textContent = 'Add To Cart';
          }, 1200);
        })
        .catch(function (error) {
          addButton.dataset.loading = 'false';
          addButton.disabled = false;
          if (addButtonText) addButtonText.textContent = 'Try Again';
          console.error('Unable to add product to cart:', error);
        });
    }

    card.addEventListener('mouseenter', preloadCardImages, { once: true });

    controls.forEach(function (control) {
      control.addEventListener('change', updateVariant);
      if (control.type === 'radio') {
        control.parentElement.addEventListener('mouseenter', function () {
          if (control.dataset.previewImage) showImage(control.dataset.previewImage);
        });
        control.parentElement.addEventListener('mouseleave', function () { showImage(selectedImage); });
      }
    });

    if (media && hoverImage) {
      media.addEventListener('mouseenter', function () { showImage(hoverImage); });
      media.addEventListener('mouseleave', function () { showImage(selectedImage); });
    }

    if (addButton) addButton.addEventListener('click', addToCart);
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart();
      });
    }

  }

  function init(root) {
    (root || document).querySelectorAll('[data-olle-product-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
